export enum UserIncompleteField {
  PhoneNumber = "PhoneNumber",
}
